import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Gennemgå ordre',
    [StepEnum.OrderPayment]: 'Betaling',
  },
};
